exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n", ""]);

